<div class="app-layout" [class.no-sidebar]="!showLayout()">
  <app-sidebar *ngIf="showLayout()"></app-sidebar>

  <div class="app-content">
    <router-outlet></router-outlet>
    <app-notification-panel></app-notification-panel>
  </div>

  <app-footer *ngIf="showLayout()"></app-footer>
  <app-ai-chat-trigger *ngIf="showLayout()"></app-ai-chat-trigger>
</div>